import { render, staticRenderFns } from "./ticket_root_types.vue?vue&type=template&id=78d8db9a&scoped=true&"
import script from "./ticket_root_types.vue?vue&type=script&lang=js&"
export * from "./ticket_root_types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d8db9a",
  null
  
)

export default component.exports